export function uniqueList(targetList: []) {
  if (!Array.isArray(targetList)) {
    return [];
  }
  return targetList.filter((value, index, self) => self.indexOf(value) === index);
}

export function uniqueObjectList<T>(targetList: T[], findIndex: (item: T, list: T[] ) => number) {
  if (!Array.isArray(targetList)) {
    return [];
  }
  return targetList.filter((value, index, self) => {
    return findIndex(value, self) === index;
  });
}